import { Container, Grid } from '@material-ui/core';
import Analytics from 'components/analytics';
import CookieBanner from 'components/cookie-banner';
import { FeatureGatedContent } from 'components/feature-gated-content';
import routes from 'index.routes';
import PageNotFound from 'pages/page-not-found';
import { PrimeFilterProvider } from 'pages/search/prime/prime-context';
import { useUser } from 'providers/user/use-user';
import React, { Suspense } from 'react';
import { NotFoundBoundary, Router, View, useCurrentRoute } from 'react-navi';
import AccountLinkingRedirector from '../../pages/account/account-linking-redirector';
import { CompanyRenewalRedirector } from '../../pages/account/company-renewal-redirector';
import EmailChangeWarning from '../../pages/account/email-change-warning';
import Footer from '../footer';
import Header from '../header';
import './app.scss';

/**
 * Root application component.
 */
const App: React.FC = () => {
  const user = useUser();

  return (
    <Router
      routes={routes}
      context={{ user }}
    >
      <AppRouterContent />
    </Router>
  );
};

const AppRouterContent: React.FC = () => {
  const route = useCurrentRoute();
  const pathname = route?.url?.pathname ?? '';
  const hideChrome = pathname === '/invoice';

  return (
    <>
      <Analytics />
      <div
        className="sg-app"
        id="app"
      >
        <AccountLinkingRedirector />
        <FeatureGatedContent flag='producer'>
          <CompanyRenewalRedirector />
        </FeatureGatedContent>
        {!hideChrome && <Header />}
        <main className="main">
          <Container
            className="wrapper"
            maxWidth={false}
          >
            <Grid
              className="app__grid"
              item
              xs={12}
            >
              <Suspense fallback={null}>
                <NotFoundBoundary render={() => <PageNotFound />}>
                  <PrimeFilterProvider>
                    <View />
                  </PrimeFilterProvider>
                </NotFoundBoundary>
              </Suspense>
            </Grid>
          </Container>
        </main>
        {!hideChrome && <EmailChangeWarning />}
        {!hideChrome && <CookieBanner />}
        {!hideChrome && <Footer />}
      </div>
    </>
  );
};

export default App;

(App as any).whyDidYouRender = {
  customName: 'App',
};
